import script from "./MitiServicesView.vue?vue&type=script&setup=true&lang=js"
export * from "./MitiServicesView.vue?vue&type=script&setup=true&lang=js"

import "./MitiServicesView.vue?vue&type=style&index=0&id=c1fd2484&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1fd2484"]])

export default __exports__